import { useEffect, useState } from 'react'
import type { ToastPayload } from '../lib/toast'

type Toast = ToastPayload & { id: number }

export function Toaster() {
  const [toast, setToast] = useState<Toast | null>(null)

  useEffect(() => {
    function handleToast(event: Event) {
      const detail = (event as CustomEvent<ToastPayload>).detail
      setToast({ ...detail, id: Date.now() })
    }

    window.addEventListener('closedrecord:toast', handleToast)
    return () => window.removeEventListener('closedrecord:toast', handleToast)
  }, [])

  useEffect(() => {
    if (!toast) return
    const timer = window.setTimeout(() => setToast(null), 3200)
    return () => window.clearTimeout(timer)
  }, [toast])

  if (!toast) return null

  return (
    <div className="fixed bottom-5 left-1/2 z-[80] w-[min(92vw,440px)] -translate-x-1/2 rounded-3xl border border-white/15 bg-[#1D1D86]/95 p-4 text-sm font-bold text-white shadow-[0_24px_80px_rgba(5,5,40,0.45)] backdrop-blur-xl">
      {toast.message}
    </div>
  )
}
